import { createSlice } from '@reduxjs/toolkit';
import {
  createInquiry,
  fetchInquiries,
  fetchCountries,
  fetchStates,
  fetchDistricts,
  fetchLocalAreas,
  fetchBusinessTypes,
  fetchBusinessCategories,
  fetchBusinessServices
} from './inquiryThunks';

const initialState = {
  profile: null,
  inquiries: [],
  countries: [],
  states: [],
  districts: [],
  localAreas: [],
  businessTypes: [],
  businessCategories: [],
  businessServices: [],
  loading: false,
  error: null,
};

const inquirySlice = createSlice({
  name: 'inquiry',
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    const pending = (state) => { state.loading = true; state.error = null; };
    const rejected = (state, action) => { state.loading = false; state.error = action.payload; };

    builder
      .addCase(createInquiry.pending, pending)
      .addCase(createInquiry.fulfilled, (state, action) => { state.loading = false; state.inquiries.push(action.payload); })
      .addCase(createInquiry.rejected, rejected)

      .addCase(fetchInquiries.pending, pending)
      .addCase(fetchInquiries.fulfilled, (state, action) => { state.loading = false; state.inquiries = action.payload; })
      .addCase(fetchInquiries.rejected, rejected)

      .addCase(fetchCountries.pending, pending)
      .addCase(fetchCountries.fulfilled, (state, action) => { state.loading = false; state.countries = action.payload; })
      .addCase(fetchCountries.rejected, rejected)

      .addCase(fetchStates.pending, pending)
      .addCase(fetchStates.fulfilled, (state, action) => { state.loading = false; state.states = action.payload; })
      .addCase(fetchStates.rejected, rejected)

      .addCase(fetchDistricts.pending, pending)
      .addCase(fetchDistricts.fulfilled, (state, action) => { state.loading = false; state.districts = action.payload; })
      .addCase(fetchDistricts.rejected, rejected)

      .addCase(fetchLocalAreas.pending, pending)
      .addCase(fetchLocalAreas.fulfilled, (state, action) => { state.loading = false; state.localAreas = action.payload; })
      .addCase(fetchLocalAreas.rejected, rejected)

      .addCase(fetchBusinessTypes.pending, pending)
      .addCase(fetchBusinessTypes.fulfilled, (state, action) => { state.loading = false; state.businessTypes = action.payload; })
      .addCase(fetchBusinessTypes.rejected, rejected)

      .addCase(fetchBusinessCategories.pending, pending)
      .addCase(fetchBusinessCategories.fulfilled, (state, action) => { state.loading = false; state.businessCategories = action.payload; })
      .addCase(fetchBusinessCategories.rejected, rejected)

      .addCase(fetchBusinessServices.pending, pending)
      .addCase(fetchBusinessServices.fulfilled, (state, action) => { state.loading = false; state.businessServices = action.payload; })
      .addCase(fetchBusinessServices.rejected, rejected);
  }
});

export default inquirySlice.reducer;
